<template>
  <div class="btn-group btn-group-toggle" data-toggle="buttons">
    <label class="btn" :class="{ 'btn-primary': locale === 'en',
    'btn-outline-primary': locale !== 'en' }">
      <input type="radio" name="language" id="en" value="en"
             v-model="locale" @change="changeLanguage"> EN
    </label>
    <label class="btn" :class="{ 'btn-primary': locale === 'fr',
    'btn-outline-primary': locale !== 'fr' }">
      <input type="radio" name="language" id="fr" value="fr" v-model="locale"
             @change="changeLanguage"> FR
    </label>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  props: {
    initialLanguage: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      locale: localStorage.getItem('locale') || 'en',
    };
  },
  methods: {
    changeLanguage() {
      localStorage.setItem('locale', this.locale);
      this.$emit('language-changed', this.locale);
    },
  },
};
</script>
<style scoped>
.btn-group-toggle {
  display: inline-flex;
}
.btn {
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-primary {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}
.btn-outline-primary {
  color: var(--primary);
  background-color: transparent;
  border-color: var(--primary);
}
.btn-group-toggle .btn input[type="radio"] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}
</style>
